const cs = () => import( /* webpackChunkName: "localization.app.cs" */ './cs');
const en = () => import( /* webpackChunkName: "localization.app.en" */ './en');

export default {
	cs,
	en
};
